export default "__VITE_ASSET__XgqMhFOp__"